class MFRProductCardVariants {
  constructor( i, e, options ) {
    this.$index = i
    this.$element = $( e )

    this.selectors = {
      product: ".product-card",
      productImage: ".product-card-large__image img",
      variant: ".product-card__variant",
      selectID: "form select[name='id']",
      inputID: "form input[name='id']",
      buttonPrice: ".button .price .price-item"
    }


    this.init()
  }

  init() {
    this.$variant = this.$element.find(this.selectors.variant)
    this.$product = this.$element.find(this.selectors.product)

    this.__handleMouseEvents();
  }

  __handleMouseEvents() {
    const obj = this;

    const updateProductImage = (element, variant) => {
      const id = variant.data("id");
      const src = variant.data("src");
      const url = variant.data("url");
      const price = variant.data("price");
      const product = element.closest(obj.selectors.product);
      const image = product.find(obj.selectors.productImage);
      const inputID = product.find(obj.selectors.inputID);
      const selectID = product.find(obj.selectors.selectID);
      const buttonPrice = product.find(obj.selectors.buttonPrice);

      inputID.val(id);
      selectID.val(id);
      image.attr({ src, srcset: src });
      product.attr("href", url);
      // buttonPrice.text(price);
    };

    this.$variant.on("click mouseover mouseleave", function (event) {
      const $selected = $(this).parent().find(".is-selected");
      const variant = event.type === "mouseleave" ? $selected : $(this);

      updateProductImage($(this), variant);

      if(event.type == "click") {
        $selected.removeClass("is-selected");
        $(this).addClass("is-selected");
      }
    });

    $(document).on("click", this.selectors.product, function (e) {
      const $target = $(e.target);

      if ($target.is("button") || $target.closest("button").length) {
          return; // Allow button events to proceed naturally
      }

      const $productLink = $(this).closest(obj.selectors.product);
      if ($productLink.length) {
          window.location.href = $productLink.attr("href");
      }
  });
  }
}